import React, { useState } from 'react';
import uuid from 'uuid/v1';
import PropTypes from 'prop-types';
import { map, filter, find, isEmpty } from 'lodash';
import { Button, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TablePagination from '../TablePagination';

import TableButtonCell from '../../atoms/TableButtonCell';

import { ENTRY_DATA_TYPES } from '../../../modules/graphic-elements';

const ITEMS_PER_PAGE = 11;

const GraphicAttributeStep = ({
  dataNamedType,
  attributes,
  numericProperties,
  namedProperty,
  updateNumericAttributes,
  updateNamedAttribute,
  changeEditionStep
}) => {
  const [currentPage, changePage] = useState(1);
  const skip = currentPage * ITEMS_PER_PAGE - ITEMS_PER_PAGE;
  const attributesToShow = filter(
    attributes,
    (tableRow, index) => index >= skip && index < skip + ITEMS_PER_PAGE
  );
  return (
    <div className="m-5">
      <p>Choose your attribute</p>
      <Table responsive hover size="sm" className="text-truncate">
        <thead>
          <tr>
            <th>Numeric</th>
            {dataNamedType !== ENTRY_DATA_TYPES.NONE && <th>Named</th>}
            <th />
          </tr>
        </thead>
        <tbody>
          {map(attributesToShow, attribute => (
            <tr key={uuid()} style={{ cursor: 'pointer' }}>
              <TableButtonCell>
                <Button
                  variant={find(numericProperties, ['property', attribute]) ? 'success' : 'light'}
                  onClick={() => updateNumericAttributes(attribute)}
                >
                  <FontAwesomeIcon
                    icon={[
                      'far',
                      find(numericProperties, ['property', attribute]) ? 'check-circle' : 'circle'
                    ]}
                    size="lg"
                  />
                </Button>
              </TableButtonCell>
              {dataNamedType !== ENTRY_DATA_TYPES.NONE && (
                <TableButtonCell>
                  <Button
                    variant={namedProperty === attribute ? 'success' : 'light'}
                    onClick={() => updateNamedAttribute(attribute)}
                  >
                    <FontAwesomeIcon
                      icon={['far', namedProperty === attribute ? 'check-circle' : 'circle']}
                      size="lg"
                    />
                  </Button>
                </TableButtonCell>
              )}
              <td>{attribute}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <TablePagination
        totalCount={attributes.length}
        itemsPerPage={ITEMS_PER_PAGE}
        currentPage={currentPage}
        changePage={changePage}
        isPaginationOn
      />
      <Button
        variant="success"
        className="float-right"
        onClick={() => changeEditionStep(2)}
        disabled={
          isEmpty(numericProperties) ||
          (isEmpty(namedProperty) && dataNamedType !== ENTRY_DATA_TYPES.NONE)
        }
      >
        Save
      </Button>
    </div>
  );
};
GraphicAttributeStep.propTypes = {
  dataNamedType: PropTypes.string.isRequired,
  attributes: PropTypes.array.isRequired,
  numericProperties: PropTypes.array.isRequired,
  namedProperty: PropTypes.string.isRequired,
  updateNamedAttribute: PropTypes.func.isRequired,
  updateNumericAttributes: PropTypes.func.isRequired,
  changeEditionStep: PropTypes.func.isRequired
};

export default GraphicAttributeStep;
